import DoneRoundedIcon from '@mui/icons-material/DoneRounded';
import HourglassEmptyRoundedIcon from '@mui/icons-material/HourglassEmptyRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import ReplayRoundedIcon from '@mui/icons-material/ReplayRounded';
import FileDownloadOffIcon from '@mui/icons-material/FileDownloadOff';

export const OCCUPATIONS = [
  'WORKER',
  'EMPLOYEE',
  'PUBLIC EMPLOYEE',
  'MILITARY',
  // 'MANAGER',
  'FREELANCE',
  'RETIRED',
  // 'STUDENT',
  'CARETAKER',
];

export const SOURCES = [
  // 'BRANCH_INITIATIVE',
  'CUSTOMER_INITIATIVE',
  // 'TLMK_CALL_CENTER',
  'TLMK_BRANCH',
  // 'PREMIUMBANK',
  'WORD_OF_MOUTH',
  'AFTER_SALE',
  'OTHERS',
  // 'SOCIAL',
  // 'BILLBOARDS',
  // 'ONLINE_LOANS',
];

export const PURPOSES = [
  'HOME_RENOVATION',
  'PURCHASE_AUTO_MOTO',
  'PURCHASE_FURNITURE',
  'TRAVELS',
  'MEDICAL_CARE',
  'PAY_OFF',
  'LIQUIDITY',
  'OTHER',
];

export const PRODUCT_SOURCE = [
  'AUTO',
  'POS',
  'GARANTITO',
  'NON GARANTITO',
  'PROSPECT',
  'DEALER',
];

export const PRACTICE_SORTING = [
  {
    label: 'DATELOADINGPRACTICE',
    value: 'dateLoadingPractice',
    isDefault: true,
  },
];

export const PRODUCT_TYPES = [
  'PP',
  // 'DOC',
  'PROXY',
  'CQ',
  // 'CQS',
  // 'CQP',
  'CREDIT_CARD',
  'BANK_ACCOUNT',
  // 'LOAN',
  'INSERTEDDBCARDACCOUNT',
];

export const PRODUCT_CODES = [
  '01 - PRESTITO PERSONALE',
  '02 - REPEAT',
  '03 - DISINTERMEDIATO AUTOMOTIVE',
  '04 - DISINTERMEDIATO ALTRI BENI',
  '05 - CONSOLIDAMENTO DEL DEBITO',
  '06 - PRESTITI CON TRATTENUTA DIP',
  '07 - DIPENDENTI AZIENDE DOC',
  '11 - REWRITE',
  '13 - CQS PRIVATI',
  '14 - CQS STATALI CREDITONET',
  '15 - CQS NO CREDITONET',
  '16 - CQS MINISTERIALI CREDITONET',
  '17 - DELEGAZIONE PAGAMENTO',
  '18 - CQP INPS',
  '19 - CQP NO INPS',
  '34 - CQP EX INPDAP',
  '35 - CQP ENPALS',
  '37 - CQS PARAPUBBLICO CREDITONET',
  '99 - VIVIBANCA',
];

export const PRACTICE_ICONS = {
  ACCEPTED: DoneRoundedIcon,
  PENDING: HourglassEmptyRoundedIcon,
  REJECTED: CloseRoundedIcon,
  RETREATED: ReplayRoundedIcon,
  NOTINSERTED: FileDownloadOffIcon,
  //WITHDRAWN: CloseRoundedIcon,
};

export const PRACTICE_COLORS = {
  ACCEPTED: '#34A853',
  PENDING: '#BCBCBC',
  REJECTED: '#b00020',
  RETREATED: '#c6cbf0',
  NOTINSERTED: '#BCBCBC',
  //WITHDRAWN: '#f5a644',
};
export const AGES = ['18-30', '31-45', '46-65', 'Over 65'];
